// extracted by mini-css-extract-plugin
export const alert = "CreditTotalsOverview__alert__Nf722";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const subtitle = "CreditTotalsOverview__subtitle__g0ehW";
export const textCenter = "CreditTotalsOverview__textCenter__LQZT4";
export const title = "CreditTotalsOverview__title__cWNtA";
export const tooltipIconWrapper = "CreditTotalsOverview__tooltipIconWrapper__x3+g3";